(function () {
  function initGAByo(root) {
    var scope = root && root.querySelector ? root : document;
    var shell =
      scope.querySelector('[data-ga-byo]') ||
      document.querySelector('[data-ga-byo]');

    if (!shell || shell.dataset.gaByoReady === 'true') return;

    shell.dataset.gaByoReady = 'true';
    document.documentElement.classList.add('ga-byo-template-active');

    var initialCount = parseInt(
      shell.getAttribute('data-initial-count') || '12',
      10
    );

    var visibleCount = initialCount;
    var activeFilter = 'all';
    var toastTimer;
    var gaStickyRaf = null;

    /* =========================================================
       PINNED BUILD-YOUR-OWN NAV
       BASE · CHARMS · STYLE · LOOKS · SHOP ALL

       Uses a fixed pinned state after the nav reaches the
       visible bottom of the Shopify header. This avoids theme
       wrappers interfering with CSS position:sticky.
    ========================================================= */

    var stickyNav = shell.querySelector('[data-ga-byo-sticky]');
    var stickyPlaceholder = null;

    if (stickyNav) {
      stickyPlaceholder = document.createElement('div');
      stickyPlaceholder.className = 'ga-byo-sticky-nav-placeholder';
      stickyNav.parentNode.insertBefore(stickyPlaceholder, stickyNav);
    }

    function getHeaderBottom() {
      var header =
        document.querySelector('#shopify-section-header') ||
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.header-wrapper') ||
        document.querySelector('header.header');

      if (!header) return 0;

      var rect = header.getBoundingClientRect();
      return Math.max(0, Math.round(rect.bottom));
    }

    function updatePinnedNav() {
      if (!stickyNav || !stickyPlaceholder) return;

      var headerBottom = getHeaderBottom();

      document.documentElement.style.setProperty(
        '--ga-byo-sticky-top',
        headerBottom + 'px'
      );

      if (!stickyNav.classList.contains('is-pinned')) {
        stickyPlaceholder.style.height = stickyNav.offsetHeight + 'px';
      }

      var triggerTop = stickyPlaceholder.getBoundingClientRect().top;

      if (triggerTop <= headerBottom) {
        stickyNav.classList.add('is-pinned');
        stickyPlaceholder.classList.add('is-active');
        stickyPlaceholder.style.height = stickyNav.offsetHeight + 'px';
      } else {
        stickyNav.classList.remove('is-pinned');
        stickyPlaceholder.classList.remove('is-active');
        stickyPlaceholder.style.height = '0px';
      }
    }

    function refreshGAStickyTop() {
      if (gaStickyRaf) return;

      gaStickyRaf = window.requestAnimationFrame(function () {
        gaStickyRaf = null;
        updatePinnedNav();
      });
    }

    /* =========================================================
       TOAST
    ========================================================= */

    function showToast(message) {
      var toast = shell.querySelector('[data-ga-byo-toast]');
      if (!toast) return;

      toast.textContent = message;
      toast.classList.add('is-visible');

      window.clearTimeout(toastTimer);

      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 1800);
    }

    /* =========================================================
       SMOOTH SECTION NAVIGATION
    ========================================================= */

    function scrollToTarget(anchor) {
      var selector = anchor.getAttribute('href');

      if (!selector || selector.charAt(0) !== '#') return;

      var target = document.querySelector(selector);
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    shell
      .querySelectorAll('[data-ga-byo-anchor]')
      .forEach(function (anchor) {
        anchor.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToTarget(anchor);
        });
      });

    /* =========================================================
       CHARM FILTERS + LOAD MORE
    ========================================================= */

    function updateCharmGrid() {
      var cards = Array.prototype.slice.call(
        shell.querySelectorAll('[data-ga-charm-card]')
      );

      var matchingCount = 0;

      cards.forEach(function (card) {
        var finish =
          card.getAttribute('data-ga-charm-finish') || '';

        var matches =
          activeFilter === 'all' ||
          finish === activeFilter;

        if (!matches) {
          card.hidden = true;
          return;
        }

        matchingCount += 1;

        if (activeFilter === 'all') {
          card.hidden = matchingCount > visibleCount;
        } else {
          card.hidden = false;
        }
      });

      var more = shell.querySelector('[data-ga-charms-more]');

      if (more) {
        if (activeFilter !== 'all') {
          more.hidden = true;
        } else {
          more.hidden = visibleCount >= matchingCount;
        }
      }
    }

    shell
      .querySelectorAll('[data-ga-charm-filter]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          activeFilter =
            button.getAttribute('data-ga-charm-filter') ||
            'all';

          shell
            .querySelectorAll('[data-ga-charm-filter]')
            .forEach(function (item) {
              var selected = item === button;

              item.classList.toggle(
                'is-active',
                selected
              );

              item.setAttribute(
                'aria-pressed',
                selected ? 'true' : 'false'
              );
            });

          updateCharmGrid();
        });
      });

    var moreButton =
      shell.querySelector('[data-ga-charms-more]');

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        visibleCount += initialCount;
        updateCharmGrid();
      });
    }

    /* =========================================================
       CART COUNT
    ========================================================= */

    function updateCartBubble() {
      fetch('/cart.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document
            .querySelectorAll(
              '.cart-count-bubble,' +
              '[data-cart-count],' +
              '.header__cart-count,' +
              '.cart-count'
            )
            .forEach(function (el) {
              var number =
                el.querySelector(
                  'span[aria-hidden="true"]'
                ) || el;

              number.textContent = cart.item_count;

              el.style.display =
                cart.item_count > 0 ? '' : 'none';
            });
        })
        .catch(function () {});
    }

    /* =========================================================
       QUICK ADD
    ========================================================= */

    function addVariant(button) {
      var variantId =
        button.getAttribute('data-variant-id');

      if (!variantId || button.disabled) return;

      var cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      button.disabled = true;
      button.classList.add('is-loading');

      var config;

      if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');

        if (config.headers) {
          config.headers['X-Requested-With'] =
            'XMLHttpRequest';

          delete config.headers['Content-Type'];
        }
      } else {
        config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        };
      }

      var formData = new FormData();

      formData.set('id', variantId);
      formData.set('quantity', '1');

      if (
        cart &&
        typeof cart.getSectionsToRender === 'function'
      ) {
        formData.append(
          'sections',
          cart
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        if (
          typeof cart.setActiveElement === 'function'
        ) {
          cart.setActiveElement(button);
        }
      }

      config.body = formData;

      var cartAddUrl =
        window.routes &&
        window.routes.cart_add_url
          ? window.routes.cart_add_url
          : '/cart/add.js';

      fetch(cartAddUrl, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            throw new Error(
              response.description ||
                'This item could not be added.'
            );
          }

          button.classList.add('is-added');

          showToast('Added to bag');

          var details =
            button.closest('details');

          if (details) {
            details.removeAttribute('open');
          }

          if (
            cart &&
            typeof cart.renderContents === 'function' &&
            response.sections
          ) {
            cart.renderContents(response);
          } else {
            updateCartBubble();

            document.dispatchEvent(
              new CustomEvent('cart:refresh')
            );

            document.dispatchEvent(
              new CustomEvent('cart:updated')
            );

            window.dispatchEvent(
              new CustomEvent('cart:refresh')
            );
          }

          window.setTimeout(function () {
            button.classList.remove('is-added');
          }, 1400);
        })
        .catch(function (error) {
          showToast(
            error.message ||
              'Unable to add to bag'
          );
        })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
        });
    }

    shell.addEventListener('click', function (event) {
      var button =
        event.target.closest('[data-ga-byo-add]');

      if (
        !button ||
        !shell.contains(button)
      ) {
        return;
      }

      event.preventDefault();
      addVariant(button);
    });

    /* =========================================================
       CLOSE VARIANT DRAWERS WHEN CLICKING OUTSIDE
    ========================================================= */

    document.addEventListener(
      'click',
      function (event) {
        shell
          .querySelectorAll(
            '[data-ga-byo-variants][open]'
          )
          .forEach(function (details) {
            if (!details.contains(event.target)) {
              details.removeAttribute('open');
            }
          });
      }
    );

    /* =========================================================
       AUTOMATIC CHARM LOOKS
       IN STOCK / PREORDER FIRST
    ========================================================= */

    function initAutomaticCharmLooks() {
      var lookGrid =
        shell.querySelector(
          '[data-ga-byo-look-grid]'
        );

      if (!lookGrid) return;

      var lookCards =
        Array.prototype.slice.call(
          lookGrid.querySelectorAll(
            '[data-ga-byo-look-card]'
          )
        );

      lookCards.sort(function (a, b) {
        var aStock = parseInt(
          a.getAttribute('data-stock-rank') || '0',
          10
        );

        var bStock = parseInt(
          b.getAttribute('data-stock-rank') || '0',
          10
        );

        if (aStock !== bStock) {
          return bStock - aStock;
        }

        var aSequence = parseInt(
          a.getAttribute('data-sequence') || '0',
          10
        );

        var bSequence = parseInt(
          b.getAttribute('data-sequence') || '0',
          10
        );

        return bSequence - aSequence;
      });

      lookCards.forEach(
        function (card, index) {
          lookGrid.appendChild(card);
          card.hidden = index >= 4;
        }
      );

      var looksSection =
        shell.querySelector(
          '.ga-byo-section--looks'
        );

      if (
        looksSection &&
        lookCards.length === 0
      ) {
        looksSection.hidden = true;
      }
    }

    /* =========================================================
       INITIALISE
    ========================================================= */

    updatePinnedNav();
    updateCharmGrid();
    initAutomaticCharmLooks();

    window.addEventListener(
      'scroll',
      refreshGAStickyTop,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      refreshGAStickyTop
    );

    window.addEventListener(
      'load',
      refreshGAStickyTop
    );

    /*
      If the header changes height after load —
      for example mobile header, announcement bar,
      market selector etc — recalculate automatically.
    */
    if ('ResizeObserver' in window) {
      var headerToWatch =
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.header-wrapper');

      if (headerToWatch) {
        var headerObserver =
          new ResizeObserver(
            refreshGAStickyTop
          );

        headerObserver.observe(
          headerToWatch
        );
      }
    }
  }

  /* =========================================================
     BOOT
  ========================================================= */

  function boot() {
    initGAByo(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initGAByo(
        event.target || document
      );
    }
  );
})();